import { render } from "./App.vue?vue&type=template&id=5df16c0f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5df16c0f&lang=scss"

import exportComponent from "/Users/myeonghoonjeon/git/pawinhand_shelter_manager/PawinhandAPIServer/front/pawinhand_shelter_manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__